import { z } from 'zod'
// role/model, not the role index: role/api imports PermissionMapSchema, and the index would make that a cycle.
import { RoleIdSchema } from '../role/model'
import { EntityIdSchema } from '../ids'

export const PermissionEntityIdSchema = z.union([EntityIdSchema, RoleIdSchema])
